import React from 'react';
import BlockWrapper from './BlockWrapper';
import Container from '../interface/Container';
import TwoColumnText from '../TwoColumn/TwoColumn';

const TwoColumnBlock = ({ block }) => {
  return (
    <BlockWrapper>
      <Container>
        <TwoColumnText
          mainTitle={block.mainTitle}
          text={block.text}
          linkTitle={block.linkTitle}
          ctaUrl={block.ctaUrl}
        />
      </Container>
    </BlockWrapper>
  );
};
export default TwoColumnBlock;
